import styled from '../styles/styled';
import buttonsWrapperStyle from './styles';

const ButtonsWrapper = styled('div')(buttonsWrapperStyle);

export default ButtonsWrapper;
